import http from "@/utils/request"

export default {
	device_category: {
		list: async function (data = {}) {
			return await http.get("device_category/list", data);
		},
		add: async function (data = {}) {
			return await http.post("device_category/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("device_category/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("device_category/del", data);
		},
		option: async function (data = {}) {
			return await http.get("device_category/option", data);
		},
	},
	device_group: {
		list: async function (data = {}) {
			return await http.get("device_group/list", data);
		},
		add: async function (data = {}) {
			return await http.post("device_group/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("device_group/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("device_group/del", data);
		},
		option: async function (data = {}) {
			return await http.get("device_group/option", data);
		},
	},
}
